(function () {

  'use strict';

  function pxGenerativeAiDirective(
    $filter, $rootScope, $timeout, toastr, RegexModel, CopilotService
  ) {

    const emptyConfigurations = {
      PRINTIX: {
        enabled: false,
        type: 'PRINTIX',
        apiUrl: 'N/A',
        apiKey: 'N/A',
        model: 'N/A'
      },
      CHATGPT_OPEN_AI: {
        enabled: false,
        type: 'CHATGPT_OPEN_AI',
        apiUrl: 'https://api.openai.com/v1/chat/completions',
        apiKey: '',
        model: ''
      },
      AZURE_OPEN_AI: {
        enabled: false,
        type: 'AZURE_OPEN_AI',
        apiUrl: '',
        apiKey: '',
        model: 'N/A'
      }
    };

    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/generativeAi/generativeAi.template.html',
      link: function (scope, element) {

        scope.me = $rootScope.currentUser;

        const urlChecker = (new RegexModel()).urlRegex();
        scope.isGlobalProviderAvailable = CopilotService.state.isGlobalProviderAvailable;
        const defaultConfiguration = scope.isGlobalProviderAvailable ? { ...emptyConfigurations.PRINTIX } : { ...emptyConfigurations.CHATGPT_OPEN_AI };
        scope.isLoading = false;
        scope.isDialog = scope.meta !== undefined;
        scope.wasEnabled = false;

        scope.$watch(function () {
          return $rootScope.currentUser;
        }, function () {
          if ($rootScope.currentUser) {
            scope.me = $rootScope.currentUser;
          }
        });

        function getGenerativeAiConfiguration() {
          scope.isLoading = true;
          CopilotService.getConfiguration()
            .then(function (configuration) {
              scope.configuration = configuration || { ...defaultConfiguration };
              scope.wasEnabled = scope.configuration.enabled;
              if (scope.isGlobalProviderAvailable === undefined) {
                scope.isGlobalProviderAvailable = CopilotService.state.isGlobalProviderAvailable;
              }
              if (configuration === undefined) {
                $timeout(function () {
                  scope.validateInput();
                });
              }
              clearErrors(scope);
            })
            .catch(function () {
              toastr.error($filter('translate')('ERROR'));
            })
            .finally(function () {
              scope.isLoading = false;
            });
        }

        scope.changeProviderType = function () {
          const desiredProviderType = scope.configuration?.type;
          scope.configuration = { ...(emptyConfigurations[desiredProviderType] || defaultConfiguration) };
          clearErrors(scope);
          scope.validateInput();
        };

        scope.validateInput = function () {
          scope.apiUrlInvalid = scope.configuration.type !== 'PRINTIX' &&
            !urlChecker.test(scope.configuration.apiUrl);
          // API key is required, but it is not returned from the server. So check for either
          // API key (which must be specified to save) or version (which will only exist after saving).
          scope.apiKeyInvalid = scope.configuration.type !== 'PRINTIX' &&
            !(scope.configuration.apiKey || scope.configuration.version);
          scope.modelInvalid = scope.configuration.type !== 'PRINTIX' &&
            scope.configuration.type !== 'AZURE_OPEN_AI' && !scope.configuration.model;
          scope.saveEnabled = !scope.apiUrlInvalid && !scope.apiKeyInvalid && !scope.modelInvalid;
        };

        scope.cancelAndExit = function () {
          scope.callback();
          CopilotService.setConfigurationOpen(false);
        };

        scope.saveChanges = function () {
          scope.isUpdating = true;
          CopilotService.saveConfiguration(scope.configuration)
            .then(function (configuration) {
              if (angular.isObject(configuration)) {
                scope.configuration = configuration;
                scope.wasEnabled = scope.configuration.enabled;
              }
              toastr.success($filter('translate')('ChangesSaved'));
              scope.callback();
            })
            .catch(function () {
              scope.apiUrlInvalid = true;
              toastr.error($filter('translate')('GenAICredentialError'));
            })
            .finally(function () {
              scope.isUpdating = false;
            });
        };

        element.on('keydown keypress', function (event) {
          if (event.which === 13) {
            event.preventDefault();
            scope.$apply(function () {
              if (scope.saveEnabled) {
                scope.saveChanges();
              }
            });
          }
        });

        (function () {
          getGenerativeAiConfiguration();
          scope.changeProviderType();
          CopilotService.setConfigurationOpen(true);
        })();

        scope.$on('$destroy', function () {
          CopilotService.setConfigurationOpen(false);
        });

      }
    };

    function clearErrors(scope) {
      scope.apiUrlInvalid = false;
      scope.apiKeyInvalid = false;
      scope.modelInvalid = false;
    }
  }

  pxGenerativeAiDirective.$inject = ['$filter', '$rootScope', '$timeout', 'toastr', 'RegexModel', 'CopilotService'];

  angular
    .module('printix-admin')
    .directive('pxGenerativeAiDirective', pxGenerativeAiDirective);

})();
